var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iDalgo-Result-Other"},_vm._l((_vm.players),function(section,key){return _c('i-dalgo-section-min',{key:("sectionResult-" + key),attrs:{"section":section,"total":_vm.count,"active":true}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6989e842","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/iDalgo-Result-Other.vue
// module id = null
// module chunks = 